<template>
  <div class="manage-user">

    <!-- START Search Box -->
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3">
                <b-form-group label-class="col-form-label"
                              label="Search" label-for="userSearchBox"
                              label-cols="3" content-cols="9">
                  <b-input-group>
                    <b-form-input id="userSearchBox" type="search" placeholder="이름 or 이메일" v-model="searchWord" />
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START User List -->
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">
            <div style="max-height: 66vh;">

              <div class="row mb-2">
                <div class="col">
                  <div class="float-end me-2">
                    <total-count :count="paginationOptions.totalCount" unit="건"/>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="common-sticky-table">
                  <b-table class="datatables text-nowrap"
                           tbody-tr-class="text-start"
                           hover bordered show-empty
                           responsive sticky-header="53vh" no-border-collapse
                           selectable select-mode="single" selected-variant="secondary"
                           sort-by="id"
                           :fields="fields" :items="items"
                           :filter="searchWord"
                           :filter-included-fields="filterFields"
                           :filter-debounce="150"
                           :per-page="paginationOptions.perPage"
                           :current-page="paginationOptions.currentPage"
                           @row-selected="selectRow"
                           @row-dblclicked="openUpdateModal">
                  </b-table>
                </div>
              </div>

              <div class="row">
                <div class="mt-3">
                  <b-pagination class="mb-1 pagination-no-border" size="sm" align="center" v-model="paginationOptions.currentPage"
                                first-number last-number prev-text="<" next-text=">"
                                :total-rows="paginationOptions.totalCount"
                                :per-page="paginationOptions.perPage"/>
                </div>
              </div>

              <div class="row">
                <div class="manage-btns-container">
                  <b-button variant="outline-deep-green" class="me-3" :disabled="!selectedRow" @click="openUpdateModal(selectedRow)">수정</b-button>
                  <b-button variant="outline-deep-green" :disabled="!selectedRow" @click="deleteUser()">삭제</b-button>
<!--                  <b-button variant="info" @click="isCreateModalShow = true">등록</b-button>-->
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END User List -->

    <b-modal v-model="isUpdateModalShow"
             centered scrollable no-close-on-backdrop
             header-class="bg-modal-header"
             ok-title="저장" cancel-title="취소"
             @ok="updateUser"
             @cancel="() => {userRole = selectedRow.roles}">
      <template #modal-header>
        <div class="fw-bold">사용자 수정</div>
      </template>

      <div>
        <MDKForm
            :fields="formFields"
            :entity="selectedRow? selectedRow : {}"
            :read-only="true"
        >
          <template v-slot:inputs="props">
            <template v-if="props.column.key === 'roles'">
              <MDKInput :field="props.column"
                        v-model="userRole"
              />
            </template>
          </template>
        </MDKForm>
      </div>
    </b-modal>

    <b-modal v-model="isCreateModalShow"
             centered scrollable no-close-on-backdrop
             header-class="bg-modal-header"
             ok-title="저장" cancel-title="취소"
             @ok="createUser">

      <template #modal-header>
        <div class="fw-bold">사용자 등록</div>
      </template>

      <div>
        <MDKForm
            :fields="formFields"
            :entity="{roles: 'USER,'}"
            @change="onFieldChanged"
        >
        </MDKForm>
      </div>
    </b-modal>

  </div>
</template>

<script>
import TotalCount from "@/views/components/totalCount.vue";

export default {
  name: "manageUser",
  components: { TotalCount },
  data() {
    const _api = this.$_app.service.account;
    return {
      jqlApi: _api,
      fields: [
        // _api.schema.id,
        _api.schema.name,
        _api.schema.roles,
        _api.schema.email
      ],
      items: [],
      searchWord: null,
      filterFields: [ 'name', 'email' ],
      paginationOptions: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10,
      },
      isUpdateModalShow: false,
      isCreateModalShow: false,
      selectedRow: '',
      userRole: '',
      newUser: {},
      formFields: [
        // _api.schema.id,
        _api.schema.name,
        _api.schema.roles,
        _api.schema.email
      ]
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    selectRow(row) {
      const vm = this;

      vm.selectedRow = row[0];
      vm.userRole = row[0].roles;
    },
    openUpdateModal(row) {
      const vm = this;

      vm.selectedRow = row;
      vm.isUpdateModalShow = true;
      vm.userRole = row.roles;
    },
    updateUser() {
      const vm = this;
      vm.selectedRow.roles = vm.userRole;
      vm.jqlApi.updateByIdList(vm.selectedRow.id, vm.selectedRow)
        .then(res => {
          vm.$swal("수정완료", '성공적으로 수정되었습니다.', 'success')
        })
    },
    onFieldChanged(valueSet, err, field) {
      // console.log(valueSet);
      this.newUser = {...valueSet, emailVerified: false, provider: 'local'};
    },
    deleteUser() {
      const vm = this;

      this.$swal({
        title: `사용자 "${vm.selectedRow.name}" 삭제하시겠습니까?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }).then (result => {
        if (result.isConfirmed) {
          vm.jqlApi.deleteByIdList(vm.selectedRow.id)
            .then(res => {
              vm.$swal("삭제완료", '성공적으로 삭제되었습니다.', 'success')
                .then(result => {
                  if (result.isConfirmed) vm.getItems();
                });
            })
        }
      });
    },
    createUser() {
      const vm = this;

      vm.jqlApi.add(vm.newUser)
      .then(res => {
        vm.$swal('등록완료', '성공적으로 등록되었습니다.', 'success')
      })
      .catch(err => {
        console.log(err)
        vm.$swal('등록실패', '등록에 실패하였습니다.', 'error')
        vm.getItems();
      })
    },
    getItems(filterOptions, sortOptions) {
      const vm = this;
      vm.jqlApi.searchByJql(filterOptions, sortOptions, 2000, 1)
      .then(res => {
        vm.items = res.content;
        vm.paginationOptions.totalCount = res.totalElements;
      }).catch(err => {
        console.log(err);
      });
    }
  },

}
</script>
